import { useEditorContext } from "../EditorContext";
import FormLabel from "../FormCommonField/FormLabel";
import { getBorderStyleObj } from "../FormText/FormBaseStyle";
import DownArrowIcon from "../SideContent/DownArrowIcon";

export default ({ data }) => {
  const {
    placeholder,
    paddingTop,
    paddingBottom,
    paddingRight,
    paddingLeft,
  } = data;
  
  const { state } = useEditorContext();
  const borderStyleObj = getBorderStyleObj(state.root.data);

  return (
    <div
      style={{
        paddingTop,
        paddingBottom,
        paddingRight,
        paddingLeft,
        textAlign: "left",
      }}
    >
      <FormLabel data={data} />
      <div style={{ display: "flex", gap: 8 }}>
        <div
          style={{
            width: 120,
            height: 38,
            position: "relative",
            ...borderStyleObj,
          }}
        >
          <div style={{ position: "absolute", right: 10, width: 16, top: 10 }}>
            <DownArrowIcon />
          </div>
        </div>
        <div
          style={{
            width: "100%",
            height: 38,
            position: "relative",
            display: "flex",
            alignItems: "center",
            ...borderStyleObj,
          }}
        >
          {placeholder && (
            <div
              style={{
                padding: "0 8px",
                color: "#707070",
              }}
            >
              {placeholder}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
